import apiClient from './client';

export const usersAPI = {
  // Get all users
  getAllUsers: async () => {
    const response = await apiClient.get('/users');
    return response.data;
  },

  // Get user by ID
  getUserById: async (id) => {
    const response = await apiClient.get(`/users/${id}`);
    return response.data;
  },

  // Create admin user (Super Admin only)
  createAdmin: async (userData) => {
    const response = await apiClient.post('/users/admins', userData);
    return response.data;
  },

  // Create staff user (Admin and Super Admin)
  createStaff: async (userData) => {
    const response = await apiClient.post('/users/staff', userData);
    return response.data;
  },

  // Update user
  updateUser: async (id, userData) => {
    const response = await apiClient.put(`/users/${id}`, userData);
    return response.data;
  },

  // Delete user
  deleteUser: async (id) => {
    const response = await apiClient.delete(`/users/${id}`);
    return response.data;
  },

  // Lock user
  lockUser: async (id, reason) => {
    const response = await apiClient.post(`/users/${id}/lock`, { reason });
    return response.data;
  },

  // Unlock user
  unlockUser: async (id) => {
    const response = await apiClient.post(`/users/${id}/unlock`);
    return response.data;
  },

  // Reset user password
  resetUserPassword: async (id, temporaryPassword) => {
    const response = await apiClient.post(`/users/${id}/reset-password`, {
      temporary_password: temporaryPassword,
      generate_password: !temporaryPassword
    });
    return response.data;
  },

  // ============================================================
  // ROLE MANAGEMENT
  // ============================================================

  // Change user role
  changeUserRole: async (userId, role, branchId = null) => {
    const response = await apiClient.patch(`/users/${userId}/role`, { 
      role, 
      branchId 
    });
    return response.data;
  },

  // Get manageable roles for current user
  getManageableRoles: async () => {
    const response = await apiClient.get('/users/manageable-roles');
    return response.data;
  },

  // Set branch admin
  setBranchAdmin: async (branchId, userId) => {
    const response = await apiClient.post(`/branches/${branchId}/admin`, { userId });
    return response.data;
  },

  // Remove branch admin
  removeBranchAdmin: async (branchId) => {
    const response = await apiClient.delete(`/branches/${branchId}/admin`);
    return response.data;
  },

  // Create staff for a specific branch
  createBranchStaff: async (branchId, staffData) => {
    const response = await apiClient.post(`/branches/${branchId}/staff`, staffData);
    return response.data;
  }
};

// Convenience function for getting users (used by task modals)
export const getUsers = async (params = {}) => {
  const response = await apiClient.get('/users', { params });
  return response.data;
};
